import { applyInitialFieldsToFile } from "@/state/transactions/CurrentTransactionEvents";
import PdfViewer from "@components/core/pdf/PdfViewer";
import InitialFields from "@components/core/subComponents/InitialFields/InitialFields";
import { InitialFieldsAlignment } from "@type/core/dashboard/dashboard.types";
import { TransactionType } from "@type/core/transaction/transaction.types";
import { Col } from "antd";

interface PdfContainerLeftPanelProps {
  src: string | undefined;
  index: number;
  transactionType: TransactionType;
  setLoading: (loading: boolean) => void;
  setPageNumber: (pageNumber: number) => void;
  isInitialFieldsActivated: boolean;
  initialFieldsY: number;
  pageNumber: number;
  initialFieldsAlignment: InitialFieldsAlignment;
  filename: string;
  getTotalPageNumber: (totalPageNumber: number) => void;
  setInitialFieldsY: (initialFieldsY: number) => void;
}

const PdfContainerLeftPanel: React.FC<PdfContainerLeftPanelProps> = ({
  src,
  index,
  setLoading,
  setPageNumber,
  isInitialFieldsActivated,
  initialFieldsY,
  initialFieldsAlignment,
  pageNumber,
  filename,
  transactionType,
  getTotalPageNumber,
  setInitialFieldsY,
}: PdfContainerLeftPanelProps) => {
  return (
    <Col span={24} sm={12} data-test="document" id={"leftPanel_" + index}>
      {src && (
        <PdfViewer
          url={src}
          setLoading={setLoading}
          onPageChange={setPageNumber}
          getTotalPageNumber={getTotalPageNumber}
        />
      )}
      {transactionType === "signature" && (
        <InitialFields
          isInitialFieldsActivated={isInitialFieldsActivated}
          alignment={initialFieldsAlignment}
          y={initialFieldsY}
          setY={(y) => {
            applyInitialFieldsToFile({
              fileName: filename,
              y,
              alignment: initialFieldsAlignment,
            });
            setInitialFieldsY(y);
          }}
          rank={index}
          pageNumber={pageNumber}
        />
      )}
    </Col>
  );
};

export default PdfContainerLeftPanel;
